export function normalizeReportPath(value) {
  const raw = String(value || '').trim();
  const cleaned = raw
    .replace(/^https?:\/\/[^/]+/i, '')
    .replace(/^\/+/, '')
    .replace(/\/+$/, '');

  return cleaned || 'reports/historical-jobs-report';
}

export function reportBasePath(path) {
  return '';
}
